import { render, staticRenderFns } from "./learnover.vue?vue&type=template&id=40443b9b&scoped=true&"
import script from "./learnover.vue?vue&type=script&lang=js&"
export * from "./learnover.vue?vue&type=script&lang=js&"
import style0 from "./learnover.vue?vue&type=style&index=0&id=40443b9b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40443b9b",
  null
  
)

export default component.exports